module.exports = __webpack_public_path__ + "028204887384f82d25eabbbf61af72e8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/loose-skin/loose-skin-1a.jpg
 ** module id = 437
 ** module chunks = 0
 **/